import { useEffect } from 'react';
import { preloadImage } from '@utils/common';

function usePreloadedIntroductions(component) {
  useEffect(() => {
    const requestIdleCallback = cb => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(cb);
      } else {
        setTimeout(() => {
          cb();
        }, 1_500);
      }
    };
    requestIdleCallback(() => {
      const introductions = component.tasks.flatMap(it => it.type === "stack" ? it.tasks : [it]).map(it => it.introduction);
      for (const introduction of introductions) {
        const images = introduction.filter(it => it.type === "Image");
        images.map(img => preloadImage(img.src));
      }
    });
  }, [component.tasks]);
}

export { usePreloadedIntroductions };
//# sourceMappingURL=hook.preloaded-introductions.js.map
